import { render, staticRenderFns } from "./participants.vue?vue&type=template&id=0a82808a"
import script from "./participants.vue?vue&type=script&lang=js"
export * from "./participants.vue?vue&type=script&lang=js"
import style0 from "./participants.vue?vue&type=style&index=0&id=0a82808a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports